<template>
  <b-nav-item-dropdown
    no-caret
    right
    class="mx-2"
    title="Notificações"
    @shown="find(0)"
  >
    <template #button-content>
      <b-icon
        icon="bell-fill"
        style="color: #ffff"
        :class="{ 'b-icon-animation-throb text-danger': hasNotification }"
      ></b-icon>
    </template>

    <b-dropdown-text class="b-dropdown-tl-1">
      Notificações Recentes</b-dropdown-text
    >
    <b-dropdown-divider></b-dropdown-divider>
    <div class="calc-card-dropdown  overflow-auto">
      <b-dropdown-text
        class="text-right c-pointer text-all-notification"
        @click="checkAll()"
      >
        Marcar todas como lida</b-dropdown-text
      >
      <NotificationItem
        v-for="item in list"
        :key="item.id"
        :type="item.type"
        :date="item.date"
        :id="item.id"
        :isNew="item.new"
      />
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import request from "../../request/request";
import NotificationItem from "./NotificationItem";
import { eventPagePath, eventUserPath } from "../../router/ApiPaths";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Notifications",
  extends: request,
  components: {
    NotificationItem
  },
  data() {
    return {
      list: [],
      limit: 10
    };
  },
  computed: {
    ...mapGetters({
      hasNotification: "hasNotification"
    })
  },
  methods: {
    find() {
      this.get(eventPagePath + this.limit).then(data => {
        this.list = data;
        this.setNotification(false);
      });
    },
    checkAll() {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].new) {
          this.post(
            eventUserPath,
            {
              eventId: this.list[i].id
            },
            (i + 1) <= this.list.length
          );
          this.list[i].new = false;
        }
      }
    },
    ...mapActions({
      setNotification: "setNotification"
    })
  }
};
</script>

<style>
.b-dropdown-date {
  font-size: 11px;
  color: #548CA8;
  font-weight: 500;
}

.b-dropdown-tl-1 {
  font-size: 17px;
  font-weight: 600 !important;
  color: #334257;
}

.b-dropdown-tl-2 {
  font-size: 0.78571429em;
  color: #548CA8;
  font-weight: 500 !important;
  text-transform: uppercase;
}

.calc-card-dropdown {
  width: 340px;
  max-height: calc(90vh - 100px);
  min-height: 300px;
}

.b-dropdown-text {
  font-weight: 600;
}

.text-all-notification {
  font-size: 14px;
  color: #42526e;
}
</style>



// WEBPACK FOOTER //
// src/view/header/Notifications.vue